import React from 'react';
import { navigate } from "@reach/router"

export default function LandingPage(props) {
    React.useEffect(() => {
        return navigate(`https://cestasey.cz/`)
    })
    return (<></>)
}